import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { TareaService } from '../../../../services/tarea.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AccionTarea, NuevaTarea } from '../../../../models/Tarea';
import { ScnackbarData, ToastService, SnackbarStyles } from '../../../../commons/toast.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-avance',
    imports: [
        MatDialogModule, MatDialogActions, MatDialogClose, MatDialogContent,
        MatButtonModule, MatIconModule,
        FormsModule, ReactiveFormsModule, MatFormFieldModule,
        MatSelectModule,
        MatInputModule,
        MatProgressSpinnerModule
    ],
    templateUrl: './avance.component.html',
    styleUrl: './avance.component.scss'
})
export class AvanceComponent {
  readonly dialogRef = inject(MatDialogRef<AvanceComponent>);
  readonly data = inject<NuevaTarea>(MAT_DIALOG_DATA);

  nuevaTarea: NuevaTarea

  porcentajesAvance = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100]

  avanceForm = new FormGroup({
    porcentaje: new FormControl("", {
      validators: [Validators.required]
    }),
    comentario: new FormControl("", {
      validators: [Validators.required]
    })
  })

  fetchingAvanceTarea = false

  snackbarData: ScnackbarData = {}

  constructor(
    private tareaService: TareaService,
    private toast: ToastService
  ) {
    this.nuevaTarea = structuredClone(this.data)
  }

  close() {
    this.fetchingAvanceTarea = true
    const formControls = this.avanceForm.controls
    const accionTareas: AccionTarea[] = [
      {
        id: this.nuevaTarea.id,
        idParticipante: this.nuevaTarea.idAsignado,
        comentario: formControls.comentario.value!,
        avance: parseInt(formControls.porcentaje.value!),
        fechaExpira: this.nuevaTarea.fechaExpira
      }
    ]
    this.tareaService.reportarAvanceTarea(accionTareas).subscribe({
      next: (_) => {
        this.snackbarData.message = "Avance registrado"
        this.snackbarData.style = SnackbarStyles.Success
        this.snackbarData.iconName = "check_circle"
        this.fetchingAvanceTarea = false
        this.toast.show(this.snackbarData)
        this.dialogRef.close({ success: true })
      },
      error: (_) => {
        this.snackbarData.message = "Error registrando avance"
        this.snackbarData.style = SnackbarStyles.Error
        this.snackbarData.iconName = "error"
        this.fetchingAvanceTarea = false
        this.toast.show(this.snackbarData)
        this.dialogRef.close({ success: false })
      }
    })
  }

}
